import { Dispatch, useEffect, useState } from 'react';
import {
  getAdminRequests,
  getHeaders,
  IApiCallStatus,
  IError,
  IRequest,
  ISaveRequestOutput,
  ResponseCSOSHeaders,
  useUserContext,
} from '../common';
import { compose as lcompose, map as lmap } from 'lodash/fp';
import { assocPath } from 'rambda';
import { fold, map as emap } from 'fp-ts/lib/Either';

export const useAdminRequests = () => {
  const { user } = useUserContext();
  const [requests, setRequests] = useState<ISaveRequestOutput[]>([]);
  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();

  useEffect(() => {
    lcompose(
      emap(handleRequests({ setRequests, setApiCallStatus })),
      getHeaders
    )(user);
  }, [user]);

  return { requests, apiCallStatus };
};

const handleRequests = ({
  setRequests,
  setApiCallStatus,
}: {
  setRequests: Dispatch<ISaveRequestOutput[]>;
  setApiCallStatus: Dispatch<IApiCallStatus>;
}) =>
  lcompose(
    () => setApiCallStatus(null),
    (hR: ResponseCSOSHeaders) =>
      getAdminRequests(hR)
        .then(
          fold<IError, IRequest[], void>(
            () => setApiCallStatus(false),

            lcompose(
              () => setApiCallStatus(true),
              setRequests,
              lmap<IRequest, ISaveRequestOutput>(
                lcompose(assocPath('msgCode', null), assocPath('msgText', null))
              )
            )
          )
        )
        .catch(() => setApiCallStatus(false))
  );
